import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

const MonitorCard = ({
  title,
  date = '',
  showFilterBtn = true,
  hasData = false,
  children,
  color = 'blue'
}) => {
  // Color mapping for different variants
  const colorClasses = {
    blue: {
      text: 'text-sky-300',
      border: 'border-sky-400/15'
    },
    green: {
      text: 'workspace-monitor-accent-text',
      border: 'workspace-monitor-card--accent'
    },
    red: {
      text: 'text-rose-300',
      border: 'border-rose-400/15'
    },
    purple: {
      text: 'text-violet-300',
      border: 'border-violet-400/15'
    },
    yellow: {
      text: 'text-amber-300',
      border: 'border-amber-400/15'
    },
    indigo: {
      text: 'text-indigo-300',
      border: 'border-indigo-400/15'
    }
  };

  const currentColor = colorClasses[color] || colorClasses.green;
  return (
    <div className="h-full flex flex-col">
      <div
        className={`workspace-monitor-card rounded-md border ${currentColor.border} p-4 flex-1 flex flex-col`}
      >
        <div className="flex justify-between items-start mb-2">
          <div>
            <h2 className={`text-lg font-semibold ${currentColor.text}`}>{title}</h2>
            <p className="text-sm text-slate-400">
              {date}{' '}
              {showFilterBtn && (
                <button className={`${currentColor.text} font-medium ml-2`}>Change Filters</button>
              )}
            </p>
          </div>
          <EllipsisVerticalIcon className="w-5 h-5 text-slate-500" />
        </div>

        <div
          className={
            hasData ? 'text-slate-300' : 'flex justify-center items-center h-32 text-slate-500'
          }
        >
          {hasData ? children : 'No Data to Display'}
        </div>
      </div>
    </div>
  );
};

export default MonitorCard;

MonitorCard.propTypes = {
  title: PropTypes.string,
  date: PropTypes.string,
  showFilterBtn: PropTypes.bool,
  hasData: PropTypes.bool,
  children: PropTypes.node,
  color: PropTypes.string
};
